<!-- Generator: Adobe Illustrator 26.4.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg
    version="1.1"
    id="Ebene_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 395.4 70.9"
    style="enable-background:new 0 0 395.4 70.9;"
    xml:space="preserve"
>
    <style type="text/css">
        .st0 {
            fill: #e30613;
        }
    </style>
    <g>
        <g>
            <rect x="4" y="5.9" width="8" height="56.8" />
            <path d="M8,34.3" />
        </g>
        <polygon points="37.5,5.9 46.8,5.9 21.6,32.4 48.7,62.7 38.9,62.7 12,32.7 	" />
        <polygon
            points="53.9,5.9 93.2,5.9 93.2,12.6 61.9,12.6 61.9,30.1 91.3,30.1 91.3,36.8 61.9,36.8 61.9,56.1 94.4,56.1 94.4,62.7 
		53.9,62.7 	"
        />
        <polygon
            points="102.9,5.9 112,5.9 142.4,51.7 142.4,5.9 150.3,5.9 150.3,62.7 141.2,62.7 110.8,17 110.8,62.7 102.9,62.7 	"
        />
        <path
            d="M344.5,5.9h21.6c8.6,0,14.9,3.3,19.1,8.5c4.2,5.2,6.2,12.3,6.2,19.9c0,7.6-2,14.7-6.2,19.9c-4.2,5.2-10.5,8.5-19.1,8.5
		h-21.6V5.9z M352.5,56.1h13.2c5.3,0,9.7-2.2,12.9-6.1c3.1-3.8,5-9.3,5-15.7c0-6.4-1.8-11.9-5-15.7c-3.1-3.8-7.6-6.1-12.9-6.1h-13.2
		V56.1z"
        />
        <polygon
            points="202.4,49.3 219.9,5.9 227.9,5.9 202.8,66.7 191.5,41.5 180.3,66.7 155.2,5.9 163.2,5.9 180.7,49.3 191.5,26.1 	"
        />
        <polygon class="st0" points="182.1,5.9 201,5.9 191.5,26.1 	" />
        <path
            d="M311.3,64.5c-7.7,0-14.2-3.1-18.8-8.5c-4.6-5.3-7.3-12.9-7.3-21.7c0-8.8,2.7-16.3,7.3-21.7c4.6-5.3,11.1-8.5,18.8-8.5
		c7.7,0,14.2,3.1,18.8,8.5c4.6,5.3,7.3,12.9,7.3,21.7c0,8.8-2.7,16.3-7.3,21.7C325.5,61.3,319,64.5,311.3,64.5z M325.3,50.3
		c3-4.4,4.5-10.2,4.5-15.9c0-5.7-1.4-11.5-4.5-15.9c-3-4.4-7.6-7.4-14-7.4c-6.4,0-11,3-14,7.4c-3,4.4-4.5,10.2-4.5,15.9
		c0,5.7,1.4,11.5,4.5,15.9c3,4.4,7.6,7.4,14,7.4C317.7,57.7,322.3,54.7,325.3,50.3z"
        />
        <path
            d="M253,64.5c-7.7,0-14.2-3.1-18.8-8.5c-4.6-5.3-7.3-12.9-7.3-21.7c0-8.8,2.7-16.3,7.3-21.7c4.6-5.3,11.1-8.5,18.8-8.5
		c7.7,0,14.2,3.1,18.8,8.5c4.6,5.3,7.3,12.9,7.3,21.7c0,8.8-2.7,16.3-7.3,21.7C267.2,61.3,260.6,64.5,253,64.5z M267,50.3
		c3-4.4,4.5-10.2,4.5-15.9c0-5.7-1.4-11.5-4.5-15.9c-3-4.4-7.6-7.4-14-7.4c-6.4,0-11,3-14,7.4c-3,4.4-4.5,10.2-4.5,15.9
		c0,5.7,1.4,11.5,4.5,15.9c3,4.4,7.6,7.4,14,7.4C259.3,57.7,263.9,54.7,267,50.3z"
        />
    </g>
</svg>
